import { computed, onUnmounted, ref } from 'vue'
import { onKeyStroke } from '@vueuse/core'
import { defineStore } from 'pinia'

const useTargetsStore = defineStore('targetsStore', () => {
    let baseId = 0
    const targets = ref<number[]>([])
    const last = computed(() => targets.value.at(-1))

    const getId = () => {
        baseId += 1
        const id = baseId
        targets.value.push(id)

        return id
    }

    const handleIsLast = (id: number): boolean => {
        if (last.value === id) {
            targets.value.pop()

            return true
        } else {
            return false
        }
    }

    const clear = (id: number) => {
        const index = targets.value.indexOf(id)

        if (index !== -1) {
            targets.value.splice(index, 1)
        }
    }

    return {
        targets,
        getId,
        last,
        handleIsLast,
        clear,
    }
})

export function useHandleEscapeKey(handler: () => void): void {
    const { getId, handleIsLast, clear } = useTargetsStore()

    const id = getId()

    onKeyStroke('Escape', (e) => {
        e.preventDefault()
        e.stopPropagation()

        if (handleIsLast(id)) {
            handler()
        }
    })

    onUnmounted(() => clear(id))
}
